import React from "react";

export default function NoAccess() {
  return (
    <div className="flex h-full flex-col items-center justify-center px-4 text-center">
      <h1 className="text-2xl font-semibold text-gray-800">No Access</h1>
      <p className="mt-2 max-w-md text-sm text-gray-600">
        Your account does not have access to any pages. Please contact your administrator.
      </p>
    </div>
  );
}
